module.exports = __webpack_public_path__ + "static/media/p067_triangle.8f8e494d.txt";